<template>
  <div class="use-calssticket-record-list">
    <p class="text-normal text-gray-60 py-[4px]">{{ $t('member.tab.classTicket.editRecord') }}</p>

    <div v-if="displayData.length" class="flex flex-col gap-[4px] text-gray-60">
      <div v-for="item in displayData" :key="item.id" class="use-record-item" :class="gridCols">
        <div>
          <span>{{ item.typeLabel }}：</span>
          <span class="text-sm">{{ item.displayValue }}</span>
        </div>
        <p v-if="enableOrgBenefitSharing && (isClassTicketOrgEnabled || isHeadquarter)" class="text-center">{{ item.redemptionShopNName }}</p>
        <p v-if="useBranch" class="text-center">{{ item.branchName }}</p>
        <p class="text-right">{{ item.createdAt }}</p>
      </div>
    </div>

    <p v-else class="text-center text-gray-60">{{ $t('member.tab.classTicket.noEditRecord') }}</p>

    <div v-if="record.length > 3" class="flex justify-end">
      <BaseElButton type="text" class="see-all-btn" @click="allRecord = !allRecord">{{ allRecord ? $t('member.tab.classTicket.collapseRecord') : $t('member.tab.classTicket.viewAllRecord') }}</BaseElButton>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import { formatDate } from '@/utils/date'
import { get, map, slice } from 'lodash'
import { classTicketUseRecordTypeConfig } from '@/config/classTicket'
import { usePermissions } from '@/use/permissions'
import { useOrgBenefitControl } from '@/use/useOrgBenefitControl'
import { useShop } from '@/use/shop'
import { t } from '@/plugins/i18n/i18n'

const orderCodeTypes = new Set([
  'APPOINTMENT_BOOKED',
  'APPOINTMENT_UNBOOKED',
  'APPOINTMENT_CHECKED',
  'COURSE_BOOKED',
  'COURSE_UNBOOKED',
  'COURSE_CHECKED',
])

export default defineComponent({
  name: 'UseClassTicketRecordList',
  props: {
    record: { type: Array, default: () => [] },
  },
  setup (props) {
    const { checkAction } = usePermissions()
    const { isHeadquarter } = useShop()
    const { isClassTicketOrgEnabled, enableOrgBenefitSharing } = useOrgBenefitControl()
    const useBranch = computed(() => checkAction('admin.branch.page'))
    const allRecord = ref(false)

    // 使用共用 config 避免重複與不一致

    const displayData = computed(() => {
      const data = map(props.record, (item) => {
        const createdAt = get(item, 'createdAt')
        const times = get(item, 'times')
        const type = get(item, 'type')
        let displayValue = Math.abs(times)
        if (orderCodeTypes.has(type)) {
          displayValue = `${t('member.tab.classTicket.orderCode')} ${get(item, 'orderCode') || '-'}`
        }

        return {
          use: times > 0 ? times : null,
          cancel: times > 0 ? null : Math.abs(times),
          branchName: get(item, 'Branch.name') || '-',
          redemptionShopNName: get(item, 'RedemptionShop.name') || '-',
          createdAt: createdAt ? formatDate(createdAt) : '-',
          type,
          typeLabel: get(classTicketUseRecordTypeConfig, [type, 'label'], '-'),
          displayValue,
        }
      })

      if (!allRecord.value) return slice(data, 0, 3)
      return data
    })
    const gridCols = computed(() => {
      const showOrgCol = enableOrgBenefitSharing.value && (isClassTicketOrgEnabled.value || isHeadquarter.value)
      if (useBranch.value && showOrgCol) return 'grid-cols-4'
      if (useBranch.value || showOrgCol) return 'grid-cols-3'
      return 'grid-cols-2'
    })

    return { displayData, allRecord, useBranch, gridCols, isClassTicketOrgEnabled, isHeadquarter, enableOrgBenefitSharing }
  },
})

</script>

<style scoped lang="postcss">
.use-calssticket-record-list {
  @apply pt-[8px];
}
.use-record-item {
  @apply grid text-[16px];
}

.see-all-btn {
  @apply text-normal leading-[28px] p-0 text-right;
}
</style>
